import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { MainMenu } from './components/Dashboard/MainMenu'
import Home from './components/Login/Home'
import { AuthCallback } from "./components/Login/AuthCallback"
import { CreateProject, UpdateProject } from './components/Projects/Project'
import { FinanceProjectList, ProjectList } from './components/Projects/Table/ProjectList'
import { ProjectStatusReport } from './components/Report/ProjectReport'
import { CreateTask, CreateTaskFromProject } from './components/Tasks/Tasks'
import { CreateEmployee, UpdateEmployee } from './components/Employee/Employee'
import { ErrorPage } from './components/Error'
import { MonthlyCalendarPage, MonthlyCalendarPopup, WeeklyCalendarPage, WeeklyCalendarPopup } from './components/Calendar/Calendar'
import { SetAnnouncement } from './components/Announcements/Announcement'
import CreateSubmittal, { CreateSubmittalFromProject, EditSubmittal } from './components/Submittals/Submittal'
import { EditTask } from './components/Tasks/Tasks'
import { CreateRFI, CreateRFIFromProject, EditRFI } from './components/RFIs/RFI'
import { CreateInvoice, EditInvoice } from './components/Invoice/Invoice'
import { PasswordReset } from './auth/PasswordReset'
import { EmailConfirmation } from './auth/VerifyEmail'
import { Changelog } from './components/Changelog'
import { Verification } from './App'
import DragNDropTasks from './components/Tasks/DragNDrop/DragNDropTasks'
import ViewRFI from './components/RFIs/Table/RFIList'
import { SubmittalList } from './components/Submittals/Table/SubmittalList'
import { TaskList } from './components/Tasks/Table/TaskList'
import { ViewInvoices } from './components/Invoice/Table/InvoiceList'
import OnBoarding from './components/Employee/OnBoarding'
import SettingsPage from './components/Settings/Settings'
import { EditAssignment, FeedbackAssignment } from './components/Assignments/EditAssignment'
import { AssignmentList } from './components/Assignments/Table/AssignmentList'
import { EmployeeList } from './components/Employee/Table/EmployeeList'
import {
    CreatePointOfContacts,
    PointOfContactList,
    UpdatePointOfContacts
} from "@/components/PointOfContacts/PointOfContacts.tsx";
import { ClientList, CreateClient, UpdateClient } from './components/Clients/Client'
import { ClientProject } from './components/Clients/ProjectPage/ClientProject'
import { UploadFile } from './components/UploadFile/UploadFile'
import { BidList, CreateBid, UpdateBid } from './components/Bids/Bid'
import NavBarRework from './components/NavBarRework/NavBarRework'

export function AppRoutes() {
    return (
        <Router>
            <Routes>
                <Route path='/' element={<Home />} />

            {/* All routes here are checked for authentication. */}
            <Route element={<Verification />}>
                <Route element={<NavBarRework />}>
                    <Route path='/main_menu' element={<MainMenu/>} />

                    <Route path='/projects/' element={<ProjectList />} />
                    <Route path='/projects/finance' element={<FinanceProjectList />} />
                    <Route path='/projects/create_project/:template' element={<CreateProject />} />
                    <Route path='/projects/update_project/:id' element={<UpdateProject />} />
                    <Route path='/projects/upload_file/:id' element={<UploadFile />} />

                    <Route path='/tasks/create_task' element={<CreateTask />} />
                    <Route path='/tasks/update_task/:id' element={<EditTask />} />
                    <Route path='/tasks/' element={<TaskList />} />
                    <Route path='/tasks/create_task_from_project/:id' element={<CreateTaskFromProject />} />
                    <Route path='/tasks/assign_tasks/:id?' element={<DragNDropTasks />} />

                    <Route path='/submittals/create_submittal' element={<CreateSubmittal />} />
                    <Route path='/submittals/' element={<SubmittalList />} />
                    <Route path='/submittals/update_submittal/:id' element={<EditSubmittal />} />
                    <Route path='/submittals/create_submittal_from_project/:id' element={<CreateSubmittalFromProject />} />

                    <Route path='/employees/' element={<EmployeeList />} />
                    <Route path='/employees/create_employee' element={<CreateEmployee />} />
                    <Route path='/employees/update_employee/:id' element={<UpdateEmployee />} />

                    <Route path='/calendar/monthly' element={<MonthlyCalendarPage />} />
                    <Route path='/calendar/weekly' element={<WeeklyCalendarPage />} />

                    <Route path='/rfi/' element={<ViewRFI />} />
                    <Route path='/rfi/create_rfi' element={<CreateRFI />} />
                    <Route path='/rfi/create_rfi_from_project/:id' element={<CreateRFIFromProject />} />
                    <Route path='/rfi/update_rfi/:id' element={<EditRFI />} />

                    <Route path='/assignments/' element={<AssignmentList />} />
                    <Route path='/assignments/update_assignment/:id' element={<EditAssignment />} />
                    <Route path='/assignments/feedback' element={<FeedbackAssignment />} />

                    <Route path='/announcements/create_anncouncement' element={<SetAnnouncement />} />

                    <Route path='/bids/' element={<BidList />} />
                    <Route path='/bids/create_bid/:category' element={<CreateBid />} />
                    <Route path='/bids/update_bid/:id' element={<UpdateBid />} />

                    <Route path='/invoices/create_invoice' element={<CreateInvoice />} /> 
                    <Route path='/invoices/update_invoice/:id' element={<EditInvoice />} />
                    <Route path='/invoices/' element={<ViewInvoices />} />

                    <Route path={'/point_of_contact/create'} element={<CreatePointOfContacts />} />
                    <Route path={'/point_of_contact/update/:id'} element={<UpdatePointOfContacts />} />
                    <Route path={'/point_of_contact/list'} element={<PointOfContactList />} />

                    <Route path='/clients/list' element={<ClientList />} />
                    <Route path='/clients/create_client' element={<CreateClient />} />
                    <Route path='/clients/update_client/:id' element={<UpdateClient />} />

                    <Route path='/settings/' element={<SettingsPage />} />

                    <Route path='/changelog/' element={<Changelog />} />
                </Route>

                <Route path='/calendar/monthly/popup' element={<MonthlyCalendarPopup />} />
                <Route path='/calendar/weekly/popup' element={<WeeklyCalendarPopup />} />
                <Route path='/employees/onboarding/' element={<OnBoarding />} />
                <Route path='/projects/project_status_report' element={<ProjectStatusReport />} />

            </Route>

            <Route path='/clients/projects' element={<ClientProject />} />

            <Route path='/email/confirm/:key' element={<EmailConfirmation />} />
            <Route path='/password/reset/:key' element={<PasswordReset />} />

            <Route path='/auth-callback' element={<AuthCallback />} />

            <Route path='*' element={<ErrorPage />} />

            </Routes>
        </Router>
    )
}